module.exports = __webpack_public_path__ + "static/media/footlocker-logo.8688c1a7.svg";